import { withStyles } from "@material-ui/core";
import React from "react";
import StyledTooltip from "../../StyledTooltip";
import { Edit } from "@material-ui/icons";
import { isPickupEditable } from "../../utils";
const styles = (theme) => ({
    container: {
        display: 'flex'
    },
    editIcon: {
        marginLeft: 8,
        marginTop: 4,
        cursor: "pointer",
        color: theme.iconColor
    }
})
const PickupNumberRenderer = ({ classes, ...params }) => {
    return params.value ? <div className={classes.container}>
        {params.value}
        {isPickupEditable({isCompleted:params.data.isStopCompleted, isEnabled:params.context.isEditPickupEnabled}) ? <StyledTooltip title={"Edit Pickup"}>
            <div>
                <Edit className={classes.editIcon} onClick={() => params.api.runCommand({
                    action: "editPickup",
                    pickupId: params.data.pickupId.toUpperCase()
                })} />
            </div>
        </StyledTooltip> : null}
    </div> : null;
}
export default withStyles(styles)(PickupNumberRenderer)